export default {
	custom: 'custom',
	none: 'none',
	on: 'on',
	plain: 'plain',
};
